export default __webpack_public_path__ + "static/contact-management-0a833c83f3611b9e61f7a4dfd9372abe.png";